const wolfarmCloudFunction = process.env.REACT_APP_FIREBASE_WOLFARM_CLOUD_FUNCTION_URL;

export const getAnswer = async function (query) {

  let url = wolfarmCloudFunction + "?q=" + encodeURIComponent(query);

  let requestOptions = {
    method: "GET",
  };

  try{
    let result = await fetch(url, requestOptions)
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) => error);

  if (!result) {
    return false;
  }

  if (result.queryresult.numpods) {
    let answer = result.queryresult.pods[0]["subpods"];
    answer = answer[0] ? answer[0].plaintext : false;
    return answer;
  }
  }
  catch(e){
    console.log(e);
  }


};